import React from 'react'
import DashboardLayout from '../../layout/DashboardLayout'
import Icon from 'components/UI/Icons'

const GetStarted = () => {
    return (
        <DashboardLayout alt='true'>
            <div className='w-11/12 lg:w-10/12 mx-auto text-center mt-10 lg:mt-20'>
                <h1 className='text-3xl tracking-wide font-semibold'>
                    Welcome to Wood System{' '}
                    <span role='img' aria-label='hand wave'>
                        👋🏽
                    </span>
                </h1>
                <p className='opacity-50 pt-1 tracking-wide text-sm md:text-lg  md:w-10/12 xl:w-7/12 px-4 mx-auto'>
                    To complete your the setup, there are a couple of things to finish before you can start creating
                    applications. Follow the guides below
                </p>

                <div className='mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 xl:gap-10'>
                    <div className='col-span-1'>
                        <div className='bg-white border border-snow-100 rounded-lg w-full h-full flex justify-center items-center flex-col py-12 px-5 xl:px-10'>
                            <div className='w-16'>
                                <Icon name='router' />
                            </div>
                            <h3 className='text-xl font-medium mt-3'>Go live</h3>
                            <p className='text-sm text-dark-100 mt-3 opacity-50'>
                                Here you can test how our systems works, Click the button to expereince it.
                            </p>
                            <div className='mt-10'>
                                <button className='bg-green px-5 h-10 text-white rounded-xs text-sm'>
                                    Run application
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='col-span-1'>
                        <div className='bg-white border border-snow-100 rounded-lg w-full h-full flex justify-center items-center flex-col py-16 px-5 xl:px-10'>
                            <div className='w-16'>
                                <Icon name='diagnostics' />
                            </div>
                            <h3 className='text-xl font-medium mt-3'>Test Environment</h3>
                            <p className='text-sm text-dark-100 mt-3 opacity-50'>
                                Here you can test how our systems works, Click the button to expereince it.
                            </p>
                            <div className='mt-10'>
                                <button className='bg-green px-8 h-10 text-white rounded-xs text-sm'>
                                    Launch Test
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='col-span-1'>
                        <div className='bg-white border border-snow-100 rounded-lg w-full h-full flex justify-center items-center flex-col py-16 px-5 xl:px-10'>
                            <div className='w-16'>
                                <Icon name='file' />
                            </div>
                            <h3 className='text-xl font-medium mt-3'>Documentations</h3>
                            <p className='text-sm text-dark-100 mt-3 opacity-50'>
                                Here you can test how our systems works, Click the button to expereince it.
                            </p>
                            <div className='mt-10'>
                                <button className='bg-green px-5 h-10 text-white rounded-xs text-sm'>
                                    View documents
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default GetStarted
